import { memo } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

interface Props {
  title: string
}

const SectionTitle = ({ title }: Props) => (
  <Box height="s32" justifyContent="center">
    <Text.Normal size="200" weight="medium" color="grey800">
      {title}
    </Text.Normal>
  </Box>
)

export default memo(SectionTitle)
